import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';
import { DutyResponseDTO } from '../models/dutyResponseData';
@Injectable({
  providedIn: 'root',
})
export class DutiesService {
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  baseUrl = `${this.env.apiUrl}/duties`;
  selMonthName:string
  //fetch all duty data
  fetchAllDuties(params?: any): Observable<any> {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `duties${urlParams}`;
    return this.env.get(url);
  }

  activeDutiesInDepartments(locationId: string, departmentIds: string[]): Observable<any> {
    const query = `locationId=${locationId}&departmentId=${departmentIds.join(',')}`;
    const url = `duties/department?${query}`;
    return this.env.get(url);
  }

  //fetch duties in planning stepper
  fetchPlanDuties(locationDepartmentId: string, params: Record<string, string | number | boolean | undefined>) {
    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
      .join('&');
  
    const url = `duties/all/${locationDepartmentId}${queryString ? `?${queryString}` : ''}`;
    return this.env.get(url);
  }

  //save duty
  saveDuty(params: any): Observable<any> {
    let url = `duties`;
    return this.env.post(url, params);
  }

  //fetch duty by Id
  fetchSingleDutyById(dutyId: any) {
    let url = `duties/${dutyId}`;
    return this.env.get(url);
  }

  //update duty
  updateDuty(editDataId: any, params: any) {
    let url = `duties/${editDataId}`;
    return this.env.put(url, params);
  }
  //update duty status in table
  updateStatus(editDataId: any, params: any) {
    let url = `duties/${editDataId}`;
    return this.env.patch(url, params);
  }

   //new api to update duty status in table
   updateDutyStatus(editDataId: any, params: any) {
    let url = `duty-mapping/${editDataId}`;
    return this.env.patch(url, params);
  }

  //fetch duty to be mapped
  fetchDutyForMapping(locationId: any,params:any) {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `duties/available/${locationId}${urlParams}`;
    return this.env.get(url);
  }

  //fetch list of month-year
  fetchMonthYear(id: any) {
    let url = `duty-mapping/month-year?id=${id}`;
    return this.env.get(url);
  }

  //fetch details of the selected mapped duty to show duty details in Map duty dialog box
  fetchMappedDutyDetails(dutyDeptId: any) {
    let url = `duty-mapping/${dutyDeptId}`;
    return this.env.get(url);
  }

  //save mapping duty
  saveMappingDuty(params: any) {
    let url = `duty-mapping`;
    return this.env.post(url, params);
  }

  //update mapped duty
  updateMappedDuty(params: any) {
    let url = `duty-mapping`;
    return this.env.put(url, params);
  }

  //fetch member type details wrt month-year
  fetchMonthYearMemberData(id: any, month: number, year: number) {
    let url = `duty-mapping/${id}/${month}/${year}`;
    return this.env.get(url);
  }

  //fetch duties to show in the drop down list of duties to be mapped
  fetchUnmappedDepts(locId: any, dutyId: any, mapped: boolean) {
    let url = `departments/duty-mapping?mapped=${mapped}&locationId=${locId}&dutyId=${dutyId}`;
    return this.env.get(url);
  }

  //update member type data status
  updateMemberTypeStatus(dutyId: any, params: any) {
    let url = `duty-mapping/member-requirement/${dutyId}`;
    return this.env.patch(url, params);
  }

  //delete member type data status
  removeMemberTypeStatus(dutyId: any) {
    let url = `duty-mapping/member-requirement/${dutyId}`;
    return this.env.delete(url);
  }

  fetchPrevMonthMemberData(id: any, month: number, year: number) {
    let url = `duty-mapping/${id}/${month}/${year}`;
    return this.env.get(url);
  }

  //create new member type
  saveMemberType(params: any): Observable<any> {
    let url = `member-types`;
    return this.env.post(url, params);
  }
  //update existing member type
  updateMemberType(id: any, params: any): Observable<any> {
    let url = `member-types/${id}`;
    return this.env.put(url, params);
  }

    //reorder member type
    reorderMemberType(params: any): Observable<any> {
      let url = `member-types/ordering`;
      return this.env.put(url, params);
    }

  deleteMemberType(memberTypeId: any) {
    let url = `member-types/${memberTypeId}`;
    return this.env.delete(url);
  }
  //active or inactive membertype
  activeMemberType(memberTypeId: any, params:any) {
    let url = `member-types/${memberTypeId}`;
    return this.env.patch(url,params);
  }
  activateDutyForPlanning(params: any) {
    let url = `duty-mapping/activate-for-planning`;
    return this.env.patch(url, params);
  }
  fetchMonthYearList(
    locationId: any,
    departmentId: string,
    month: string,
    year: number
  ) {
    //for fetching month year to load data from previous month
    const queryParams = new URLSearchParams({
      locationId,
      departmentId,
      month,
      year: year.toString(),
    }).toString();

    // Construct the full URL with query parameters
    const url = `duties/month-year?${queryParams}`;

    return this.env.get(url);
  }
  setUpDutyFromPrevMonth(params: any) {
    let url = `duties/generate-mapping`;
    return this.env.post(url, params);
  }

  private dutyDataSubject = new Subject<any>();

  // Observable to allow other components to subscribe
  dutyData$ = this.dutyDataSubject.asObservable();

  // Method to emit the data
  emitDutyData(data: any) {
    this.dutyDataSubject.next(data);
  }

    //fetch the planning month limit for monthly configuration in both the Configuration Duties and Planning Sheet modules.
  getPlanLimit(locId: any) {
      let url = `planning/allowed-for-months?locationId=${locId}`;
      return this.env.get(url);
  }

   fetchOrgDuty(orgId: any,excludePicket?:boolean,params?:any) {
    let url = params ? `duties/organisation/${orgId}?dutyType=${params}&excludePicket=${excludePicket}` : `duties/organisation/${orgId}?&excludePicket=${excludePicket}`;
    return this.env.get(url);
  }
  deleteGlobalDuty(dutyId: any) {
    let url = `duties/${dutyId}`;
    return this.env.delete(url);
  }

  addToPreplan(payload: {  allowPrePlan: boolean; locationDepartmentId: string; dutyId: string; }) {
    const url = `duties/add-to-preplan`;
    return this.env.put(url, payload); // use PUT as per your API spec
  }

  addToPlanning(payload: {  allowForPlanning: boolean; locationDepartmentId: string; dutyId: string; }) {
    const url = `duties/add-to-plan`;
    return this.env.put(url, payload); // use PUT as per your API spec
  }

  setSelectedDutyViewInLocal(view:string){
    sessionStorage.setItem('selectedDutyView', view);
  }

  getSelectedDutyViewInLocal() {
    let locAvl = typeof window !== 'undefined' && !!window.sessionStorage;
    if (locAvl) {
      let selectedDutyView: any = sessionStorage.getItem('selectedDutyView');
      return selectedDutyView;
    }
  }

  clearSelectedDutyViewInLocal() {
    sessionStorage.removeItem('selectedDutyView'); // Clear from localStorage
  }

}
